package com.veldekar.components.srd.spells

import androidx.compose.runtime.Composable
import com.veldekar.components.srd.SpellComponent
import com.veldekar.components.srd.SpellMetadata

@Composable
public fun CreateFoodAndWaterMetadata() {
    SpellMetadata(
        spellIndex = "create-food-and-water",
        castingTime = "1 action",
        range = "30 feet",
        components = listOf(SpellComponent.VERBAL, SpellComponent.SOMATIC),
        material = null,
        duration = "Instantaneous",
        damageBase = null,
        damageScaling = null,
        savingThrow = null,
        aoe = null,
        concentration = false
    )
}
